import { useCallback, useEffect } from "react";
import { useAppStore } from "../stores/appStore";
import { getLocalDayKey } from "../utils/dailyRuntime.js";

export { getLocalDayKey } from "../utils/dailyRuntime.js";

export const useDailyRuntimeReset = (taskManager, addLog, rescheduleScheduledJobs) => {
  const runDailyReset = useCallback((now = new Date()) => {
    if (!taskManager || taskManager.migrationPaused || taskManager.transportPaused) return false;

    const state = useAppStore.getState();
    if (state.config?.dailyRuntimeResetEnabled === false) return false;

    const dayKey = getLocalDayKey(now);
    if (state.lastDailyRuntimeResetDate === dayKey) return false;

    const result = taskManager.resetDailyRuntime();
    state.resetDailyTaskExecutionData();
    state.resetScheduledJobsForDailyRuntime();
    state.markDailyRuntimeReset(dayKey);
    taskManager.rescheduleDailyTaskPlans();
    rescheduleScheduledJobs?.();
    addLog?.(
      `已完成 ${dayKey} 每日运行状态重置：取消 ${result.cancelledTimers} 个延迟任务、清空 ${result.queuedCount} 个待执行项`,
      "info"
    );
    return true;
  }, [taskManager, addLog, rescheduleScheduledJobs]);

  useEffect(() => {
    if (!taskManager) return undefined;

    runDailyReset();
    let midnightTimer = null;

    const scheduleNextReset = () => {
      const now = new Date();
      const nextMidnight = new Date(now);
      nextMidnight.setHours(24, 0, 0, 0);
      midnightTimer = setTimeout(() => {
        runDailyReset();
        scheduleNextReset();
      }, Math.max(1, nextMidnight.getTime() - now.getTime()));
    };

    scheduleNextReset();
    return () => {
      if (midnightTimer) clearTimeout(midnightTimer);
    };
  }, [taskManager, runDailyReset]);

  return { runDailyReset };
};
